module.exports = __webpack_public_path__ + "static/media/cdb21.29c77fd5.png";